import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from '@api/baseApi';
import { authApi } from '@api/authApi';
import { authMiddleware } from '@features/authentication/store/authMiddleware';
import { globalSlice } from '@store/global/slice';
import { authSlice } from '@features/authentication/store/slice';
import { orderSlice } from '@store/order/slice';
import { catProbeSlice } from '@store/cat-probe/slice';
import { partnersRegistrationSlice } from '@store/partners-registration/slice';
import { partnersOrderSlice } from '@store/partners-order/slice';
import { articleSlice } from '@pages/admin/article/store/slice';



export const store = configureStore({
	reducer: {
		[globalSlice.reducerPath]: globalSlice.reducer,
		[authSlice.reducerPath]: authSlice.reducer,
		[orderSlice.reducerPath]: orderSlice.reducer,
		[catProbeSlice.reducerPath]: catProbeSlice.reducer,
		[partnersRegistrationSlice.reducerPath]: partnersRegistrationSlice.reducer,
		[partnersOrderSlice.reducerPath]: partnersOrderSlice.reducer,
		[articleSlice.reducerPath]: articleSlice.reducer,
		[authApi.reducerPath]: authApi.reducer,
		[baseApi.reducerPath]: baseApi.reducer,
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware()
		.concat(authApi.middleware)
		.concat(baseApi.middleware)
		.concat(authMiddleware)
});



export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;